module.exports = __webpack_public_path__ + "img/1.222a97f9.jpg";